import { formatDateToYYYYMMDD, getStartAndEndDates } from "../helpers/dates";
import { APIQuery } from "./api.base";
import { APIResponse } from "../types/api.types";

export const getRange = async (start_date: Date, end_date: Date): Promise<APIResponse> => {
    return await APIQuery(`/event/get/range?start_date=${formatDateToYYYYMMDD(start_date)}&end_date=${formatDateToYYYYMMDD(end_date)}`, "GET", []);
}

export const getCurrent = async (association_id: number): Promise<APIResponse> => {
    return await APIQuery(`/event/get/current`, "GET", [{ name: "x-association-id", value: association_id + "" }]);
}

export const getPast = async (association_id: number, dates?: { start_date?: Date, end_date?: Date }): Promise<APIResponse> => {
    const { start_date, end_date } = getStartAndEndDates(dates?.start_date, dates?.end_date);
    return await APIQuery(`/event/get/past?start_date=${formatDateToYYYYMMDD(start_date)}&end_date=${formatDateToYYYYMMDD(end_date)}`, "GET", [{ name: "x-association-id", value: association_id + "" }]);
}

export const getByDate = async (association_id: number, givenDate: Date): Promise<APIResponse> => {
    return await APIQuery(`/event/get/bydate?given_date=${formatDateToYYYYMMDD(givenDate)}`, "GET", [{ name: "x-association-id", value: association_id + "" }]);
}

export const getById = async (association_id: number, event_id: number): Promise<APIResponse> => {
    return await APIQuery(`/event/get/${event_id}`, "GET", [{ name: "x-association-id", value: association_id + "" }]);
}

export const create = async (association_id: number, event: {title: string, date_start: Date, date_end: Date, type: string, description: string, location: string, report_type_id: number, team_id?: number }): Promise<APIResponse> => {
    const payload: Record<string, unknown> = {
        title: event.title,
        date_start: formatDateToYYYYMMDD(event.date_start),
        date_end: formatDateToYYYYMMDD(event.date_end),
        type: event.type,
        description: event.description,
        location: event.location,
        report_type_id: event.report_type_id,
    };

    if (event.team_id !== undefined) {
        payload.team_id = event.team_id;
    }

    return await APIQuery('/event/create', "POST", [{name: "x-association-id", value: association_id + ""}], payload);
};

export const list = async (associationId: string): Promise<APIResponse> => APIQuery("/event/list", "GET", [{ name: "X-Association-Id", value: associationId }]);
export const detail = async (eventId: number): Promise<APIResponse> => APIQuery(`/event/detail/?id=${eventId}`, "GET", []);
export const update = async (payload: Record<string, unknown>, associationId: string): Promise<APIResponse> => APIQuery("/event/update", "PUT", [{ name: "X-Association-Id", value: associationId }], payload);
export const remove = async (eventId: number, associationId: string): Promise<APIResponse> => APIQuery("/event/delete", "DELETE", [{ name: "X-Association-Id", value: associationId }], { event_id: eventId });
export const addTeam = async (payload: { event_id: number, team_id: number }, associationId: string): Promise<APIResponse> => APIQuery("/event/team/add", "POST", [{ name: "X-Association-Id", value: associationId }], payload);
export const removeTeam = async (payload: { event_id: number, team_id: number }, associationId: string): Promise<APIResponse> => APIQuery("/event/team/remove", "POST", [{ name: "X-Association-Id", value: associationId }], payload);
export const addReportType = async (payload: { event_id: number, report_type_id: number }, associationId: string): Promise<APIResponse> => APIQuery("/event/report-type/add", "POST", [{ name: "X-Association-Id", value: associationId }], payload);
export const removeReportType = async (payload: { event_id: number, report_type_id: number }, associationId: string): Promise<APIResponse> => APIQuery("/event/report-type/remove", "POST", [{ name: "X-Association-Id", value: associationId }], payload);
